import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import { NOTIFICATIONS } from './config';
import type { INotificationSlice, INotificationPayload } from './types';

const initialState: INotificationSlice = {
  notifications: {
    [NOTIFICATIONS.ctpOptIn]: {
      isEligible: false,
      isDismissed: false,
    },
    [NOTIFICATIONS.ctpFamilyUpsell]: {
      isEligible: false,
      isDismissed: false,
    },
  },
};

const notificationSlice = createAppSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationEligible(
      state,
      action: PayloadAction<INotificationPayload>,
    ) {
      const { notification, status } = action.payload;
      state.notifications[notification].isEligible = status;
    },
    setNotificationDismissed(
      state,
      action: PayloadAction<INotificationPayload>,
    ) {
      const { notification, status } = action.payload;
      state.notifications[notification].isDismissed = status;
    },
  },
});

export const { setNotificationEligible, setNotificationDismissed } =
  notificationSlice.actions;
export default notificationSlice.reducer;
